<template>
  <v-content class="pa-12">
    <!-- Nevigater -->
    <v-layout mb-12>
      <v-flex
        shrink
        d-flex
        justify-start
        align-center
        class="nevigater-link"
        @click="$router.push('/all-news')"
      >
        <span>ข่าวสารทั้งหมด</span>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <v-icon color="#3E7662">arrow_right</v-icon>
      </v-flex>
      <v-flex
        shrink
        d-flex
        justify-start
        align-center
        style="color: #3E7662;font-weight: bold;font-size: 24px;"
      >
        <span>แก้ไขข่าวสาร</span>
      </v-flex>
    </v-layout>

    <!-- Form -->
    <v-card tile>
      <v-divider
        style="background-color: #3E7662;border-width: 30px"
      ></v-divider>
      <v-divider
        style="background-color: #544A44;border-width: 2px"
      ></v-divider>
      <v-layout pl-6 py-2 style="background-color: #FBF6F3">
        <v-flex
          style="color: #000000;text-align: left;font-weight: bold"
          @click="setData"
        >
          <span>แก้ไขข่าวสาร</span>
        </v-flex>
      </v-layout>
      <v-layout px-12 py-6>
        <v-flex>
          <!-- blog 1 -->
          <v-layout>
            <v-flex style="text-align: left;font-weight: bold">
              <span>หัวข้อข่าวสาร</span>
            </v-flex>
          </v-layout>
          <v-layout mt-2>
            <v-flex style="text-align: left">
              <textarea-form
                :rows="2"
                :model="form.topicNews"
                @update-data="updateData('topicNews', $event)"
              ></textarea-form>
            </v-flex>
          </v-layout>

          <!-- blog 2 -->
          <v-layout>
            <v-flex style="text-align: left;font-weight: bold">
              <span>Caption</span>
            </v-flex>
          </v-layout>
          <v-layout mt-2>
            <v-flex style="text-align: left">
              <textarea-form
                :rows="3"
                :model="form.caption"
                @update-data="updateData('caption', $event)"
              ></textarea-form>
            </v-flex>
          </v-layout>

          <!-- blog 3 -->
          <v-layout>
            <v-flex style="text-align: left;font-weight: bold">
              <span
                >รายละเอียด
                <span style="font-weight: normal">(ข้อมูลข่าวสาร)</span></span
              >
            </v-flex>
          </v-layout>
          <v-layout mt-2 mb-8>
            <v-flex style="text-align: left">
              <!--<vue-editor-->
              <!--style="background-color: #FBF6F3"-->
              <!--id="editor"-->
              <!--useCustomImageHandler-->
              <!--@image-added="handleImageAdded"-->
              <!--v-model="form.detail"-->
              <!--&gt; </vue-editor>-->

              <editor
                v-model="form.detail"
                api-key="fppvvlbcx1bpoj5azejbsnnlyb06sxlwyaa1rlf1w03c3wgv"
                :init="{
                  height: 500,
                  menubar: true,
                  plugins:
                    'table wordcount | image | searchreplace | fullscreen | lists | visualblocks | media | link',
                  toolbar:
                    'undo redo | link image media | visualblocks | fullscreen | styleselect | forecolor backcolor bold italic underline | align | numlist bullist',
                  image_title: true,
                  automatic_uploads: true,
                  file_picker_types: 'image',
                  file_picker_callback: function(cb, value, meta) {
                    uploadImageMCE(cb, value, meta);
                  },
                }"
              />
            </v-flex>
          </v-layout>

          <!-- blog 4 -->
          <v-layout>
            <v-flex style="text-align: left;font-weight: bold">
              <span>รายละเอียดย่อย</span>
              <span style="font-weight: normal">(เช่น กำหนดการ สถานที่)</span>
            </v-flex>
          </v-layout>
          <v-layout mt-2>
            <v-flex style="text-align: left">
              <textarea-form
                :rows="3"
                :model="form.subDetails"
                @update-data="updateData('subDetails', $event)"
              ></textarea-form>
            </v-flex>
          </v-layout>

          <!-- blog 5 -->
          <v-layout>
            <v-flex mr-12 xs6 style="text-align: left;font-weight: bold">
              <span
                >รูปภาพหน้าปก
                <span style="color: red"
                  >*(ขนาดของรูปภาพที่เหมาะสมคือ 520*300 px)</span
                >
              </span>
            </v-flex>
            <v-flex xs4 style="text-align: left;font-weight: bold">
              <span>วันที่จัดกิจกรรม / วันที่ประกาศ</span>
            </v-flex>
          </v-layout>
          <v-layout mt-2>
            <v-flex mr-12 xs6 style="text-align: left;font-weight: bold">
              <v-file-input
                v-model="form.image"
                label="File input"
                outlined
                dense
                color="#3E7662"
                clearable
                background-color="#FBF6F3"
                append-icon="image_search"
                @change="onChangeImg"
              ></v-file-input>
            </v-flex>
            <v-flex xs4 style="text-align: left;font-weight: bold">
              <DateInputForm
                :model="date"
                @update-data="updateDate('date', $event)"
              ></DateInputForm>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex xs6>
              <img width="100%" :src="showImage" />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-divider
        style="background-color: #544A44;border-width: 2px"
      ></v-divider>
    </v-card>

    <!-- Button -->
    <v-layout mt-12>
      <v-flex mr-6 shrink d-flex justify-end>
        <v-btn color="#CC3D45" dark
          ><span style="font-weight: bold" @click="deleteNewsByID"
            >ลบข้อมูล</span
          ></v-btn
        >
      </v-flex>
      <v-flex mr-6 d-flex justify-end>
        <v-btn color="#FFFFFF" @click="$router.push('/all-news')">
          <span style="color: #3E7662;font-weight: bold">
            ย้อนกลับ
          </span>
        </v-btn>
      </v-flex>
      <v-flex mr-12 shrink d-flex justify-end>
        <v-btn color="#3E7662" dark
          ><span style="font-weight: bold" @click="update"
            >ยืนยันการแก้ไข</span
          ></v-btn
        >
      </v-flex>
    </v-layout>

    <loading
      color="#527281"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-content>
</template>

<script>
import TextareaForm from "../../components/input/TextareaForm";
import DateInputForm from "../../components/input/DateInputForm";
import { VueEditor } from "vue2-editor";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Editor from "@tinymce/tinymce-vue";
// import axios from "axios";
// import { domain } from "../../services/Constants";

export default {
  name: "CreateNews",
  components: {
    TextareaForm,
    VueEditor,
    DateInputForm,
    Loading,
    Editor,
  },
  data: () => ({
    id: "",
    isLoading: false,
    fullPage: true,
    form: {
      topicNews: "",
      caption: "",
      detail: "",
      subDetails: "",
      date: "",
      image: null,
    },
    showImage: null,
    date: "",
  }),
  created() {
    this.id = this.$route.query.id;
    this.getNewsByID();
  },
  methods: {
    updateData(name, val) {
      this.form[name] = val;
    },
    updateDate(name, val) {
      if (name === "date") {
        this.form.date = val.date;
        this.date = this.changeDate(val.date);
      }
    },
    uploadImageMCE(cb, value, meta) {
      var input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("accept", "image/*");
      let _this = this;

      input.onchange = function() {
        var file = this.files[0];
        var reader = new FileReader();
        reader.onload = function() {
          console.log("onload");
          var id = "blobid" + new Date().getTime();
          var blobCache = tinymce.activeEditor.editorUpload.blobCache;
          var base64 = reader.result.split(",")[1];
          var blobInfo = blobCache.create(id, file, base64);
          blobCache.add(blobInfo);

          var fd = new FormData();
          fd.append("image", file);
          fd.append("file_name", file.name);

          console.log("before dispatch");
          _this.$store.dispatch("News/uploadImage", file).then((data) => {
            console.log("after", data);
            cb(data.filePath, { title: file.name });
          });
        };
        reader.readAsDataURL(file);
      };
      input.click();
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);
      sub_year = parseInt(sub_year) + 543;
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    onChangeImg() {
      this.showImage = "";
    },
    getNewsByID() {
      this.isLoading = true;
      this.$store
        .dispatch("News/getNewsByID", this.id)
        .then((res) => {
          this.form.topicNews = res.topic;
          this.form.caption = res.shortDescription;
          this.form.detail = res.description;
          this.form.subDetails = res.eventPlace;
          this.form.date = res.eventDate;
          this.date = this.changeDate(res.eventDate);
          // this.form.image = res.mainPicture;
          this.showImage = res.mainPicture;
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    deleteNewsByID() {
      Swal.fire({
        title: "คุณต้องการลบข้อมูลหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ยืนยันการลบข้อมูล",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.$store
            .dispatch("News/deleteNewsByID", this.id)
            .then((res) => {
              this.isLoading = false;
              Swal.fire({
                title: "ลบข้อมูลสำเร็จ",
                icon: "success",
                confirmButtonColor: "#3E7662",
              }).then(() => {
                this.$router.push("/all-news");
              });
            })
            .catch((e) => {
              this.isLoading = false;
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: "ลบข้อมูลไม่สำเร็จ",
                icon: "warning",
                confirmButtonColor: "#3E7662",
              });
            });
        }
      });
    },
    update() {
      this.isLoading = true;
      this.form["id"] = this.id;
      this.$store
        .dispatch("News/updateNewsByID", this.form)
        .then((res) => {
          this.isLoading = false;
          Swal.fire({
            title: "แก้ไขข้อมูลสำเร็จ",
            icon: "success",
            confirmButtonColor: "#3E7662",
          }).then(() => {
            this.$router.push("/all-news");
          });
        })
        .catch((e) => {
          this.isLoading = false;
          if (e.response.data.errors) {
            for (var k in e.response.data.errors) {
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: e.response.data.errors[k][0],
                icon: "warning",
                confirmButtonColor: "#3E7662",
              }).then(() => {
                this.$vuetify.goTo(`#${k}`);
              });
            }
          }
          // this.isLoading = false;
          // Swal.fire({
          //     title: 'เกิดข้อผิดพลาด',
          //     text: 'แก้ไขข้อมูลไม่สำเร็จ',
          //     icon: 'warning',
          //     confirmButtonColor: '#3E7662',
          // })
        });
    },
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
      this.isLoading = true;
      this.$store
        .dispatch("News/uploadImage", file)
        .then((result) => {
          this.isLoading = false;
          let url = result.filePath; // Get url from response
          Editor.insertEmbed(cursorLocation, "image", url);
          resetUploader();
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    setData() {
      this.form.topicNews =
        "[รีวิว]”เกิดใหม่ทั้งทีก็เป็นสไลม์ไปซะแล้ว”การ์ตูนที่จะมาลบความคิดที่ว่าสไลม์เป็นแค่มอนกระจอกๆ!!";
      this.form.caption =
        "เรามักจะเจอ สไลม์ มากมายผ่านทางเกมหรืออนิเมะ และในทุก " +
        "ๆ เรื่องถึงแม้สไลม์จะเป็นตัวละครที่น่ารักขนาดไหนแต่ก็มักจะมาในบทบาทตัวประกอบหรือไม่ก็จะเป็นมอนเตอร์อ่อน ๆ " +
        "เท่านั้น แต่สำหรับเรื่อง “เกิดใหม่ทั้งทีก็เป็นสไลม์ไปซะแล้ว” นั้นไม่ใช่เลย การ์ตูนเรื่องนี้จะพาคุณเปิดมิติใหม่และเปลี่ยนความคิดทั้งหมดของคุณเกี่ยวกับสไลม์";
      this.form.detail =
        "<p><strong>มิคามิ</strong> หนุ่มมนุษย์เงินเดือนธรรมดาใช้ชีวิตธรรมดาแต่กลับตายด้วยเหตุการณ์ที่ไม่ธรรมดา " +
        "เมื่ออยู่ดี ๆ ก็มีคนร้ายที่ไหนก็ไม่รู้วิ่งถือมีดมาแทงเค้าตายคาที่ จนทำให้เค้ากลับไปเกิดใหม่ในโลกที่แม้แต่ตัวเค้าเองก็เคยเห็นแค่ในเกมการ์ตูน " +
        "แถมสิ่งมีชีวิตเท่ ๆ มีตั้งเยอะแยะแต่เค้ากลับได้เกิดมาเป็นแค่ สไลม์ ซะอย่างงั้น " +
        "แต่ที่ไหนได้เค้ากลับมีสกิลที่โคตรโกงไม่ว่าจะเป็นสกิลนักล่าที่หากกินอะไรไปก็จะสามารถเรียนรู้แล้วนำมาใช้ได้ตลอดเวลา " +
        "เช่นถ้าไปกินมังกรที่พ่นไฟได้ตัวเค้าก็จะพ่นไฟได้ แถมยังมีสกิลนักปราชญ์อีก ถ้าพูดให้เข้าใจง่าย ๆ ก็เหมือนไอออนแมนที่มีจาวิสนั่นแหละครับ " +
        "คุณสงสัยอะไรก็แค่ถามนักปราชญ์ในตัวก็จะรู้คำตอบหมดเลย " +
        "ถ้าถามว่าสไลม์พระเอกนี่โหดขนาดไหนก็โหดถึงขนาดสามารถตบผู้กล้าในตำนานตายได้ง่าย ๆ เลยล่ะครับ</p>";
      this.form.subDetails = "สามารถดูได้ผ่านทาง NETFLIX";
      this.form.date = "2020-03-03";
    },
  },
};
</script>

<style scoped>
.upload-image {
  padding: 50px 50px 50px 50px;
  font-weight: bold;
  border-style: dashed;
  border-width: 2px;
  border-color: #000;
}
</style>
